"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineTransferService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("./restservice");
const http_1 = require("@angular/common/http");
class LineTransferService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.pendingTransfersurl = '/rest-api/account/sub/v1/transfer/pendingTransfers';
        this.cancelTransferUrl = '/rest-api/account/sub/v1/transfer/expire/';
        this.resendEmailUrl = '/rest-api/account/sub/v1/transfer/resendEmail';
        this.submitTransferUrl = '/rest-api/account/sub/v1/transfer/submit';
        this.validateaccountUrl = '/rest-api/account/sub/v1/transfer/validateToAccount';
    }
    // get pending line transfers
    getPendingTransfer() {
        return this.get(this.pendingTransfersurl).pipe(operators_1.map((data) => data));
    }
    // cancel pending line transfer
    cancelTransfer(acctTransferHdrId) {
        return this.post(this.cancelTransferUrl + acctTransferHdrId).pipe(operators_1.map((data) => data));
    }
    // resend an email for transfer line
    resendTransferEmail(subscriptionId, accTransferHolderId, toAccountId, isMigrationFlow) {
        const inputArgs = new http_1.HttpParams().set('subscriptionId', subscriptionId).set('accTransferHolderId', accTransferHolderId)
            .set('toAccountId', toAccountId).set('isMigration', isMigrationFlow.toString());
        return this.post(this.resendEmailUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    // submit transfer
    submitTransferLine(transferDetails) {
        return this.post(this.submitTransferUrl, transferDetails, true).pipe(operators_1.map((data) => data));
    }
    //  validating accounts
    getValidateAccount(toAccountNumber, mobileNumber, subscriptionId, isNewCustomer) {
        let inputArgs;
        if (isNewCustomer) {
            inputArgs = new http_1.HttpParams().set('newCustomer', isNewCustomer.toString()).set('subscriptionId', subscriptionId);
        }
        else if (toAccountNumber) {
            inputArgs = new http_1.HttpParams().set('toAccountNumber', toAccountNumber).set('mobileNumber', mobileNumber).set('subscriptionId', subscriptionId);
        }
        else {
            inputArgs = new http_1.HttpParams().set('mobileNumber', mobileNumber).set('subscriptionId', subscriptionId);
        }
        return this.post(this.validateaccountUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
}
exports.LineTransferService = LineTransferService;
//# sourceMappingURL=linetransfer.service.js.map